<template>
    <div>
        <div v-if="$route.path.indexOf('_notify') === -1">
            <div>
                 <el-tabs v-model="activeName" @tab-click="handleClick">
                     <el-tab-pane label="余额流水" name="first">
                          <el-row :gutter="24">
                              <el-col :span="6">
                                  <el-date-picker size="mini" v-model="params.times" type="daterange"
                                      :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
                                      end-placeholder="结束日期" align="right">
                                  </el-date-picker>
                              </el-col>
                              <el-col :span="5">
                                 <el-input placeholder="商家id" v-model="params.merchant_id" class="input-with-select"
                                     clearable size="mini">
                                     <el-button slot="append" icon="el-icon-search" @click="searchData">搜索</el-button>
                                 </el-input>
                              </el-col>
                              <el-col :span="3">
                                  <el-button type="primary" size="mini" icon="plus" @click="getExport()">导出数据</el-button>
                              </el-col>
                          </el-row>
                          <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
                              <el-table-column prop="merchant_id" label="商户id"></el-table-column>
                              <el-table-column prop="created_at" label="日期"></el-table-column>
                              <el-table-column prop="pay_type_str" label="类型"></el-table-column>
                              <el-table-column label="交易金额">
                                  <template slot-scope="scope">
                                      {{ (scope.row.amount / 100).toFixed(2) }}
                                  </template>
                              </el-table-column>
                              <el-table-column label="当前商家余额">
                                  <template slot-scope="scope">
                                      {{ (scope.row.now_amount / 100).toFixed(2) }}
                                  </template>
                              </el-table-column>
                              <el-table-column label="交易前商家余额">
                                  <template slot-scope="scope">
                                      {{ (scope.row.total_fee / 100).toFixed(2) }}
                                  </template>
                              </el-table-column>
                              <el-table-column prop="status" label="状态">
                                  <template slot-scope="scope">
                                      <el-tag size="mini" :type="scope.row.status == 0 ? 'info' : 'success'"> {{ scope.row.status
                                              == 0 ? '失败' : '成功'
                                      }}</el-tag>
                                  </template>
                              </el-table-column>
                          </el-table>
                          <div class="content-center content-top-padded">
                              <el-pagination background layout="total, sizes, prev, pager, next"
                                  @current-change="handleCurrentChange" @size-change="handleSizeChange"
                                  :current-page.sync="params.page" :page-sizes="[10, 20, 50]" :total="total_count"
                                  :page-size="params.pagesize">
                              </el-pagination>
                          </div>
                     </el-tab-pane>
                     <el-tab-pane label="ACS划款记录" name="second">
                          <el-row :gutter="24">
                              <el-col :span="6">
                                  <el-date-picker size="mini" v-model="params.times" type="daterange"
                                      :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
                                      end-placeholder="结束日期" align="right">
                                  </el-date-picker>
                              </el-col>
                              <el-col :span="3">
                                  <el-button type="primary" size="mini" icon="plus" @click="searchData()">查询</el-button>
                                  <el-button type="primary" size="mini" icon="plus" @click="getExport()">导出数据</el-button>
                              </el-col>
                          </el-row>
                          <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
                              <el-table-column prop="created_at" label="时间"></el-table-column>
                              <el-table-column prop="title" label="标题"></el-table-column>
                              <el-table-column prop="type" label="交易类型"></el-table-column>
                              <el-table-column label="交易金额">
                                  <template slot-scope="scope">
                                      {{ (scope.row.amount / 100).toFixed(2) }}
                                  </template>
                              </el-table-column>
                              <el-table-column label="当前ACS余额">
                                  <template slot-scope="scope">
                                      {{ (scope.row.now_amount / 100).toFixed(2) }}
                                  </template>
                              </el-table-column>
                              <el-table-column label="交易前余额">
                                  <template slot-scope="scope">
                                      {{ (scope.row.before_amount/ 100).toFixed(2) }}
                                  </template>
                              </el-table-column>
                              <el-table-column prop="status" label="状态">
                                  <template slot-scope="scope">
                                      <el-tag size="mini" :type="scope.row.status == 'ok' ? 'success' : 'info'">
                                          {{ scope.row.status == 'ok' ? '成功' : '失败' }}</el-tag>
                                  </template>
                              </el-table-column>
                          </el-table>
                          <div class="content-center content-top-padded">
                              <el-pagination background layout="total, sizes, prev, pager, next"
                                  @current-change="handleCurrentChange" @size-change="handleSizeChange"
                                  :current-page.sync="params.page" :page-sizes="[10, 20, 50]" :total="total_count"
                                  :page-size="params.pagesize">
                              </el-pagination>
                          </div>

                      </el-tab-pane>
                   </el-tabs>

            </div>

        </div>
        <router-view></router-view>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import { getMerchantBalance, getBalanceExport ,getTransferAccountExport, getTransferAccountList} from "../../../api/merchant";
export default {
    components: { draggable },
    data() {
        return {
            activeName:'first',
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            dialogFormVisible: false,
            total_count: 0,
            params: {
                page: 1,
                pagesize: 20,
            },
            dataList: [],
            loading: false,
            id: "",
            row: [],
        };
    },
    computed: {
        ...mapGetters(["wheight"]),
    },
    methods: {
      handleClick(tab, event) {
            console.log(tab.index,this.activeName);
            this.params.page = 1;
            this.getDataList();
       },
        getDataList() {
            this.loading = true;
            if(this.activeName == 'first'){
                getMerchantBalance(this.params)
                    .then((response) => {
                        this.dataList = response.data.data.list;
                        this.total_count = response.data.data.total_count;
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.$message({
                            type: "error",
                            message: "获取列表信息出错",
                        });
                    });
            }else{
              getTransferAccountList(this.params)
                  .then((response) => {
                      this.dataList = response.data.data.list;
                      this.total_count = response.data.data.total_count;
                      this.loading = false;
                  })
                  .catch((error) => {
                      this.loading = false;
                      this.$message({
                          type: "error",
                          message: "获取列表信息出错",
                      });
                  });
            }

        },
        handleCurrentChange(page_num) {
            this.params.page = page_num;
            this.getDataList();
        },
        searchData() {
            this.params.page = 1;
            this.getDataList();
        },
        handleSizeChange(pageSize) {
            this.params.page = 1;
            this.params.pagesize = pageSize;
            this.getDataList();
        },
        show(row) {
            this.dialogFormVisible = true;
            this.row = row;
        },
        //export
        //export
        getExport(val) {

            if (this.params.times == '') {
                this.$message({
                    type: 'error',
                    message: '请先选择日期!'
                });
                return false;
            }
            this.$notify({
                title: '成功',
                message: '正在导出,请稍后...',
                type: 'success'
            })
               if(this.activeName == 'first'){
                  getBalanceExport(this.params).then(res => {
                      if (res.data.data.status) {
                          this.$notify({
                              title: '成功',
                              message: '正在导出请稍后!',
                              type: 'success'
                          })
                          var url = res.data.data.url
                          window.open(url)
                      } else {
                          this.$notify({
                              title: '失败',
                              message: '出错了!',
                              type: 'error'
                          })
                      }
                  })
               }else{
                 getTransferAccountExport(this.params).then(res => {
                     if (res.data.data.status) {
                         this.$notify({
                             title: '成功',
                             message: '正在导出请稍后!',
                             type: 'success'
                         })
                         var url = res.data.data.url
                         window.open(url)
                     } else {
                         this.$notify({
                             title: '失败',
                             message: '出错了!',
                             type: 'error'
                         })
                     }
                 })
               }


        },
    },
    mounted() {

        this.getDataList();

    },
};
</script>
<style scoped lang="scss">
.el-row {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }

    img {
        width: 90%;
    }
}

.el-col {
    border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// balance.vue?22e2b054